import api from 'api';

export const loadCredentials = api(
  'GET /api/partner-audiences/fields/credentials'
);
export const loadAccounts = api('GET /api/partner-audiences/fields/accounts');
export const loadDataTypes = api(
  'GET /api/partner-audiences/fields/data-types'
);
export const loadAudiences = api('GET /api/partner-audiences/fields/audiences');
export const loadOwners = api('GET /api/audiences/fields/owners');

export const loadPartners = api('GET /api/partner-audiences/fields/partners');

export const loadName = api('POST /api/partner-audiences/name');

export const loadPartnerAudiences = api(
  'GET /api/partner-audiences/fields/partner-audiences'
);

export const loadLoadIronSourceTypes = api(
  'GET /api/partner-audiences/fields/ironsource-types'
);
